module.exports = __webpack_public_path__ + "img/thumbnail-0.1994789b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-0.jpg
// module id = 0Z6L
// module chunks = 1